<template lang="html">

  <div class="recordInfo">
          <table>
              <tr>
                  <td class="tbName">楼宇名称</td>
                  <td colspan="3" class="tbContent">{{buildingInfos.buildingName}}</td>
              </tr>
              <tr>
                  <td class="tbName">物业单位</td>
                  <td class="tbContent">{{buildingInfos.tenement}}</td>
                  <td class="tbName">产权单位</td>
                  <td class="tbContent">{{buildingInfos.propertyUnit}}</td>
              </tr>

              <tr>
                  <td class="tbName">所在街乡</td>
                  <td>{{buildingInfos.jiexiang}}</td>
                  <td class="tbName">地址</td>
                  <td>{{buildingInfos.address}}</td>
              </tr>

              <tr>
                  
                  <td class="tbName">所属功能区</td>
                  <td>{{buildingInfos.park}}</td>
                  <td class="tbName">项目类型</td>
                  <td>{{buildingInfos.projectType}}</td>
                  
              </tr>

              <tr>
                  <td class="tbName">是否国有</td>
                  <td>{{buildingInfos.nationalized}}</td>
                  <td class="tbName">产业定位</td>
                  <td>{{buildingInfos.location}}</td>
              </tr>
              <tr>
                  <td class="tbName">是否愿意在市级平台对外发布推介</td>
                  <td>{{buildingInfos.isWillingCityPlatformReleaseRecommend}}</td>
                  <td class="tbName">是否愿意在区级招商工作中对外发布推介</td>
                  <td>{{buildingInfos.isWillingDistrictInvestmentWorkeleaseRecommend}}</td>
              </tr>
              <tr>
                  <td class="tbName">不希望对外发布的原因</td>
                  <td>{{buildingInfos.notPublishReason}}</td>
                  <td class="tbName">是否愿意承接国际组织办公场所</td>
                  <td>{{buildingInfos.isWillingUndertakeInterOrganizationWorkspace}}</td>
              </tr>
              <tr>
                  <td class="tbName">规划建筑面积(平方米)</td>
                  <td>{{buildingInfos.planBuildingArea}}㎡</td>
                  <td class="tbName">当前空置可招商面积</td>
                  <td>{{buildingInfos.totalVacantArea}}㎡</td>
              </tr>
              <tr>
                  <td class="tbName">招商负责人</td>
                  <td>{{buildingInfos.leadingCadre}}</td>
                  <td class="tbName">负责人手机号</td>
                  <td>{{buildingInfos.leadingCadrePhone}}</td>
              </tr>
              <tr>
                  <td class="tbName">负责人邮箱</td>
                  <td>{{buildingInfos.leadingCadreEmail}}</td>
                  <td class="tbName">周边交通情况</td>
                  <td>{{buildingInfos.trafficCondition}}</td>
                  
              </tr>
              <tr>
                  <td class="tbName">周边公共配套情况</td>
                  <td>{{buildingInfos.supportingSituation}}</td>
                  <td class="tbName">其他补充说明</td>
                  <td colspan="3">{{buildingInfos.other}}</td>
              </tr>
          </table>

  </div>

</template>

<script>
import { getBuildingInfos } from '@/api/industryInfos';
export default {
    props:['distdata'],
    watch: {
            distdata(val) {
                this.buildingInfos=val;
            }
        },
   data(){
       return{
           buildingInfos:{
              id:'',         //主键id
              buildingName:'',         //楼宇名称
              tenement:'',         //物业单位
              propertyUnit:'',         //产权单位

              longitude:'',         //楼宇坐标经度
              latitude:'',         //楼宇坐标纬度
              address:'',         //地址

              jiexiang:'',         //所在街乡（数据字典）
              jiexiangId:'',         //所在街乡id

              location:'',         //定位（数据字典）
              locationId:'',         //定位id

              park:'',         //所属功能/园区（数据字典）
              parkId:'',         //所属功能/园区id
              totalVacantArea:'',         //空置总面积（平方米）

              projectType:'',         //项目类型（数据字典）
              projectTypeId:'',         //项目类型id

              leadingCadre:'',         //招商负责人
              leadingCadrePhone:'',         //负责人手机号

              trafficCondition:'',         //周边交通情况
              supportingSituation:'',         //周边公共配套情况
              other:'',         //其他补充说明

              uploadUser:'',
              uploadUserId:'',

              image:'',         //图片地址

              status:0,         //状态0初始化1已上传/待审核2发布3审核失败4未上传
              nationalized:'',         //是否国有
              nationalizedId:'',         //是否国有
          }
       }
   },
   created(){
       this.buildingInfos = this.distdata;
   }
}
</script>

<style lang="scss" scoped>

.recordInfo{
    table{
        width: 100%;
        font-size: 14px;
        border-collapse: collapse;

        td{
            padding: 12px;
            box-sizing: border-box;
            border: 1px solid #EBEEF5;
        }

        .tbName{
            width: 15%;
            background: #FAFAFA;
        }

        .tbContent{
            width: 35%;
        }
    }
}

</style>



// WEBPACK FOOTER //
// recordBuilding.vue?3e067426